import React, { useState } from "react";
import { NavLink, Link, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import classnames from "classnames";
import Analytics from "../../../helpers/analytics";
import { List, ListItem, ListItemText, ListItemIcon, Collapse, Button } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { Logo } from "./index";
import DrawerWrapper from "../styles/Drawer.style";

const availableList = [
  "Animals",
  "Art",
  "Awesome",
  "Cooking",
  "Crashes",
  "Cute",
  "DIY",
  "Fails",
  "Family",
  "Funny",
  "Heartwarming",
  "Lifestyle",
  "Nature",
  "Newsworthy",
  "Paranormal",
  "Parenting",
  "Pets",
  "Talent",
  "Travel",
  "Trending",
  "Vehicles",
  "Weather",
  "Wildlife",
  "Workout"
];

function Drawer(props) {
  const navigate = useHistory();
  const [show, setShow] = React.useState(false);
  const [showMore, setShowMore] = React.useState(false);
  const { auth, open, location, onClose, clearAllSearch, handleLogout, getSearchResults, search } =
    props;

  const sendGA = async (clear, from, item, setLocal) => {
    await Analytics.track(from, {
      category: "LP-TopNav",
      label: item
    });

    if (clear) clearAllSearch();
    if (setLocal) localStorage.setItem("prevPath", location.pathname);

    onClose();
  };

  const getSearch = (item) => {
    let params = search.searchParams;
    params.sort = "_score";
    params.page = 1;
    params.q = item.toLowerCase();
    clearAllSearch();
    search.searchParams && getSearchResults(params);
  };

  const isActive = (match, location) => location.pathname === "/licensing/collections";

  const firstName =
    auth.loggedIn && auth.userProfile.profile
      ? String(auth.userProfile.profile.firstName).trim()
      : "";
  const lastName =
    auth.loggedIn && auth.userProfile.profile
      ? String(auth.userProfile.profile.lastName).trim()
      : "";
  const userEmail =
    auth.loggedIn && auth.userProfile.profile ? String(auth.userProfile.profile.email).trim() : "";
  const profileName = firstName === "" && lastName === "" ? userEmail : `${firstName} ${lastName}`;

  const sendGaAndGoToSearch = async (item) => {
    await sendGA(false, "CategoriesDropdown", item);
    getSearch(item);
    const url =
      item === "Trending" ? "/licensing/thewire" : `/licensing/search?q=${item.toLowerCase()}`;
    navigate.push(url);
  };

  return (
    <DrawerWrapper
      open={open}
      classes={{
        paper: "drawer-container"
      }}
      onClose={onClose}
    >
      <Logo />
      <List>
        <ListItem button className="list--profile">
          <ListItemIcon>
            {auth.loggedIn ? <AccountCircleIcon /> : <PlayCircleFilledIcon />}
          </ListItemIcon>
          {auth.loggedIn ? (
            <NavLink to="/licensing/account/profile">
              <ListItemText primary={profileName.trim()} />
            </NavLink>
          ) : (
            <ListItemText primary="Licensing Platform" />
          )}
        </ListItem>
      </List>
      <div className={classnames("list", { "list--logged": auth.loggedIn })}>
        <List>
          <ListItem button>
            <ListItemIcon />
            <NavLink
              to="/licensing"
              isActive={(match, location) => location.pathname === "/licensing"}
              activeClassName="active"
            >
              <ListItemText primary="Home" />
            </NavLink>
          </ListItem>

          <ListItem id="show-button" button onClick={() => setShow(!show)}>
            <ListItemIcon>{show ? <ExpandLess /> : <ExpandMore />}</ListItemIcon>
            <ListItemText primary="Categories" />
          </ListItem>

          <Collapse in={show} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {availableList.slice(0, 8).map((item, index) => (
                <ListItem button className="nested" key={String(index)}>
                  <a
                    id={`search-${item.toLowerCase()}`}
                    onClick={async () => await sendGaAndGoToSearch(item)}
                  >
                    <ListItemText primary={item} classes={{ primary: "nested--text" }} />
                  </a>
                </ListItem>
              ))}

              {showMore &&
                availableList.slice(8).map((item, index) => (
                  <ListItem button className="nested" key={String(index)}>
                    <a
                      id={`search-${item.toLowerCase()}`}
                      onClick={async () => await sendGaAndGoToSearch(item)}
                    >
                      <ListItemText primary={item} classes={{ primary: "nested--text" }} />
                    </a>
                  </ListItem>
                ))}

              <ListItem
                id="show-more-button"
                onClick={() => setShowMore(!showMore)}
                button
                className="nested showall"
              >
                {showMore ? "- Hide" : "+ View all"}
              </ListItem>
            </List>
          </Collapse>

          <ListItem button>
            <ListItemIcon />
            <NavLink to="/licensing/collections" isActive={isActive} activeClassName="active">
              <ListItemText primary="Collections" />
            </NavLink>
          </ListItem>

          <ListItem button>
            <ListItemIcon />
            <NavLink to="/licensing/faq">
              <ListItemText primary="FAQ" />
            </NavLink>
          </ListItem>

          <ListItem button>
            <ListItemIcon />
            <NavLink to="/licensing/pricing">
              <ListItemText primary="Pricing" />
            </NavLink>
          </ListItem>

          <ListItem button>
            <ListItemIcon />
            <NavLink to="/licensing/thewire">
              <ListItemText primary="The Wire" />
            </NavLink>
          </ListItem>

          <ListItem button>
            <ListItemIcon />
            <NavLink to="/licensing/inquiry">
              <ListItemText primary="Contact Us" />
            </NavLink>
          </ListItem>

          <ListItem button>
            <ListItemIcon />
            <NavLink to="/licensing/video-submissions">
              <ListItemText primary="Submit Video" />
            </NavLink>
          </ListItem>
        </List>
      </div>

      <List className="list--button">
        {auth.loggedIn ? (
          <div className="cta--bottom cta--bottom-logged">
            <ListItem>
              <Link
                id="view-cart-link"
                to="/licensing/checkout"
                onClick={() => sendGA(false, "LP-TopNav", "View Cart", false)}
              >
                <Button className="cta cta--type-cart" variant="contained">
                  View Cart
                </Button>
              </Link>
            </ListItem>

            <ListItem>
              <Link to="/licensing/account/lists">
                <Button className="cta cta--type-playlist" variant="outlined">
                  Playlist
                </Button>
              </Link>
            </ListItem>
            <span className="cta--span-out" onClick={handleLogout} role="presentation">
              Sign Out
            </span>
          </div>
        ) : (
          <div className="cta--bottom">
            <ListItem>
              <Link
                id="signup-link"
                to="/licensing/register"
                onClick={() => sendGA(false, "LP-TopNav", "SignUp", true)}
              >
                <Button className="cta cta--type-signup" variant="contained">
                  Sign up
                </Button>
              </Link>
            </ListItem>
            <ListItem>
              <Link
                id="signin-link"
                to="/licensing/login"
                onClick={() => sendGA(false, "LP-TopNav", "SignIn", true)}
              >
                <Button className="cta cta--type-login" variant="outlined">
                  Sign in
                </Button>
              </Link>
            </ListItem>
          </div>
        )}
      </List>
    </DrawerWrapper>
  );
}

Drawer.propTypes = {
  auth: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  clearAllSearch: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  categories: PropTypes.array
};

Drawer.defaultProps = {
  categories: []
};

export default Drawer;
